import ScrollNav from "./components/ScrollNav";
import Home from "./components/Home";
import About from "./components/About";
import Projects from "./components/Projects";
import ContactMe from "./components/ContactMe";

function Main() {
  
  const layers = [
    {
      name: "Home", 
      component: <Home />
    },
    {
      name: "About", 
      component: <About />
    },
    {
      name: "Projects", 
      component: <Projects />
    },
    {
      name: "Contact", 
      component: <ContactMe />
    },
  ]

  return (
    <>
      <ScrollNav links={layers.map(link => link.name)}/>
      {layers.map((layer, index) => (
        <div name={layer.name} key={index}>
          {layer.component}
        </div>
      ))}
    </>
  );
}

export default Main;
